import { HTTPClient } from "../utils/request";

export default {
  get: ({ query = `` }) => HTTPClient.get(`/cities${query}`),
};
